import "styles/signatureInput.less";
import { Dispatch, FC, SetStateAction } from "react";

import { Col, Checkbox } from "antd";
import PasswordInput from "components/inputs/Form/Inputs/PasswordInput";
import { Link } from "react-router-dom";

import { SignDataType } from "./SignUpForm";
import { UK_ROUTES } from "../../../constants/routes";

interface ISignInputsProps {
    setSignData: (_data: SignDataType) => void;
    signData: SignDataType;
    isCreateAccountChecked: boolean;
    setIsCreateAccountChecked: Dispatch<SetStateAction<boolean>>;
    passwordError: boolean;
    setPasswordError: Dispatch<SetStateAction<boolean>>;
    inputId: string;
    handleKeyDown?: (_event: any) => void;
}

const SignInputs: FC<ISignInputsProps> = ({
    setSignData,
    signData,
    setPasswordError,
}) => {
    const handleTermsCheckChange = (e: any) => {
        const updatedSignData = {
            ...signData,
            termsAgreed: e.target.checked,
        };
        setSignData(updatedSignData);
    };

    const handlePasswordChange = (password: string) => {
        const updatedSignData = {
            ...signData,
            password,
        };
        setSignData(updatedSignData);
    };

    return (
        <Col>
            <PasswordInput origin="signUp" required autoFocus setPasswordError={setPasswordError} handlePasswordChange={handlePasswordChange}/>

            <Checkbox
                defaultChecked
                className="input-item"
                onChange={handleTermsCheckChange}
            >
                By continuing you accept the{" "}
                <Link to={UK_ROUTES.tcs} className="email-link" target="_blank" rel="noreferrer">
                    Terms & Conditions
                </Link>{" "}
                and{" "}
                <Link to={UK_ROUTES.engagement} className="email-link" target="_blank" rel="noreferrer">
                    Terms of Engagement
                </Link>
            </Checkbox>
        </Col>
    );
};

export default SignInputs;
